import get from 'lodash/get';
import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';
import reduce from 'lodash/reduce';

import { START_NODE_ID } from 'src/presentation/components/pages/ivr/constants/ivrTreeConstants';
import { NODE_CONNECTORS_DEFS } from 'src/presentation/components/pages/ivr/constants/NodeConnectorsDefs';

// TODO: fix types - https://app.shortcut.com/gladly/story/159759/fix-types-in-configurationhelper-ts
// type HierarchyOption = { field: string; getOption?: Function } & {
//   prefixPath: string;
//   postfixPath: string;
//   getOption?: Function;
//   skipField?: Function;
// } & string;

type ChildNodeOptions = { id: string; option?: string };
export type NodesHierarchyType = { [nodeId: string]: ChildNodeOptions[] };

export const nodesHierarchy = (ivrConfig, rootNodeId): NodesHierarchyType => {
  const hierarchyMap = reduce(
    Object.entries(ivrConfig.nodesMap),
    (acc, [id, node]) => {
      const nodeType = get(node, 'type');
      const nextIdAttrs = NODE_CONNECTORS_DEFS[nodeType as any];

      if (nextIdAttrs) {
        const values = reduce(
          nextIdAttrs,
          (acc: ChildNodeOptions[], attr: any) => {
            const skipField = attr && attr.skipField && attr.skipField(node);

            if (!ivrConfig.findById(id) || skipField) {
              return acc;
            }

            if (typeof attr === 'string') {
              const id = get(node, `ivrNode.${attr}`);
              if (!id || !ivrConfig.findById(id)) {
                return acc;
              }

              return [...acc, { id }];
            }

            if (has(attr, 'field')) {
              const id = get(node, `ivrNode.${attr.field}`);
              if (!id || !ivrConfig.findById(id)) {
                return acc;
              }
              const option = attr.getOption ? attr.getOption(node) : null;
              return [...acc, { id, option }];
            }

            const items = get(node, `ivrNode.${attr.prefixPath}`, []);
            if (isEmpty(items)) {
              return acc;
            }

            return [
              ...acc,
              ...reduce(
                items,
                (acc: any, option, index: number) => {
                  const id = get(option, attr.postfixPath);

                  const opt = attr.getOption ? attr.getOption(node, option) : null;
                  if (id && ivrConfig.findById(id)) {
                    acc.push({ id, option: opt, optionIndex: index });
                  }
                  return acc;
                },
                []
              ),
            ];
          },
          []
        );

        if (values) {
          acc[id] = [...(acc[id] ? acc[id] : []), ...values];
        }
      }

      return acc;
    },
    {}
  );

  if (rootNodeId) {
    hierarchyMap[START_NODE_ID] = [{ id: rootNodeId }];
  }
  return hierarchyMap;
};
